import { useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';

import {
    FaEdit
} from 'react-icons/fa';

import Button from '../../reusable/button/button.component';

import { setMobileView } from '../../../tools/mobileView.js';

import {
  ContentContainer,
  MainContainer,
  PrinterContainer
} from '../../../styles/component.styles';

import {
  DetailsList,
  DetailRow,
  DetailTitle,
  DetailText
} from './inventory-display.styles';

const iconSize = setMobileView() ? '18px' : '28px';

const InventoryDisplay = ({ inventory, setShowUpdate = () => {}, setShowRestock = () => {} }) => {
  const [ formattedDate, setFormattedDate ] = useState(null);
  const [ barcodeError, setBarcodeError ] = useState(false);

  const barcodeRef = useRef(null);

  useEffect(() => {
    const formatDate = new Date(inventory.createdAt).toLocaleDateString('en-us', {
      day: 'numeric',
      year: 'numeric',
      month: 'short'
    });
    setFormattedDate(formatDate);
  })

  useEffect(() => {
    if (!inventory?.sku || !barcodeRef.current) return;

    try {
      JsBarcode(barcodeRef.current, inventory.sku, {
        format: 'CODE128',
        lineColor: '#000',
        width: 2,
        height: 40,
        displayValue: true
      });
      setBarcodeError(false);
    } catch (err) {
      setBarcodeError(true);
    }
  }, [inventory?.sku]);

  return (
    <MainContainer>
        {!inventory ?
          <MainContainer>
            <h2>Inventory</h2>
            <p>No inventory to display.</p>
          </MainContainer>
        :
          <>
            <PrinterContainer>
                <FaEdit onClick={() => setShowUpdate(true)} style={{ fontSize: iconSize, marginRight: '20px' }} />
            </PrinterContainer>
            <DetailsList>
              <DetailRow>
                <DetailTitle>Type:</DetailTitle>
                <DetailText>{inventory.type || '—'}</DetailText>
              </DetailRow>
              <DetailRow>
                <DetailTitle>Size:</DetailTitle>
                <DetailText>{inventory.size || '—'}</DetailText>
              </DetailRow>
              <DetailRow>
                <DetailTitle>Size Description:</DetailTitle>
                <DetailText>{inventory.sizeDescription || '—'}</DetailText>
              </DetailRow>
              <DetailRow>
                <DetailTitle>Quantity:</DetailTitle>
                <DetailText>{inventory.quantity}</DetailText>
              </DetailRow>
              <DetailRow>
                <DetailTitle>Price:</DetailTitle>
                <DetailText>${inventory.price?.toFixed(2)}</DetailText>
              </DetailRow>
              <DetailRow>
                <DetailTitle>SKU:</DetailTitle>
                <DetailText>{inventory.sku || '—'}</DetailText>
              </DetailRow>
              <DetailRow>
                <DetailTitle>Barcode:</DetailTitle>
                <DetailText>
                  {barcodeError ? (
                    <span style={{ color: 'red' }}>Invalid SKU for barcode. Please update the SKU.</span>
                  ) : (
                    <svg ref={barcodeRef} />
                  )}
                </DetailText>
              </DetailRow>
              <DetailRow>
                <DetailTitle>Bay:</DetailTitle>
                <DetailText>{inventory.bay || '—'}</DetailText>
              </DetailRow>
              <DetailRow>
                <DetailTitle>Created At:</DetailTitle>
                <DetailText>{formattedDate}</DetailText>
              </DetailRow>
              {inventory.address && (
                <DetailRow>
                  <DetailTitle>Address:</DetailTitle>
                  <DetailText>
                    {inventory.address.addressOne || ''}<br />
                    {inventory.address.addressTwo || ''}<br />
                    {inventory.address.city}, {inventory.address.state} {inventory.address.zipCode}
                  </DetailText>
                </DetailRow>
              )}
              <ContentContainer>
                <Button onClick={() => setShowRestock(true)}>Restock Inventory</Button>
              </ContentContainer>
            </DetailsList>
          </>
      }
    </MainContainer>
  );
};

export default InventoryDisplay;